// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function MapTrifoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.615 6.211a1 1 0 0 0-.857-.181l-7.642 1.91-7.668-3.835a1 1 0 0 0-.69-.075l-8 2A1 1 0 0 0 3 7v18a1 1 0 0 0 1.242.97l7.642-1.91 7.668 3.835a1.02 1.02 0 0 0 .69.075l8-2A1 1 0 0 0 29 25V7a1 1 0 0 0-.385-.789ZM13 6.617l6 3v15.765l-6-3V6.617ZM5 7.781l6-1.5V22.22l-6 1.5V7.78ZM27 24.22l-6 1.5V9.78l6-1.5V24.22Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
